// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  
  //baseUrl: 'https://cip.medsphere.net/FCM_SOC/',
  baseUrl: 'https://cip.medsphere.net/FCM2/',  
  imageUrl: 'https://cip.medsphere.net/kmpattach/',
  thumbUrl: 'https://cip.medsphere.net/kmpthumbs/',
  companyUrl: 'https://cip.medsphere.net/kmpattach/company_logo/',
  aiUrl: 'https://cip.medsphere.net/DocAI/',
  socketUrl: "wss://cip.medsphere.net:8082",


  firebaseOld: {
    apiKey: "AIzaSyD9RMkThl_SRsogS9f6v28q6rVNhFM3R-Y",
    authDomain: "pharmavisionangular.firebaseapp.com",
    projectId: "pharmavisionangular",
    storageBucket: "pharmavisionangular.appspot.com",
    messagingSenderId: "142273559231",
    appId: "1:142273559231:web:197db1d5331dc9d80e240a",
    measurementId: "G-HRZ8G98Y8P",
    vapidKey: "BOW6jWCQ4V8oC8EttR68UHW0HSlRst_XW28vxHnQwaW2R-xzIGCKWCmaWhL3YFgHJp_rVWTdbEzFc5D-JRATFxo"
  },
  
  firebase: {
    apiKey: "AIzaSyBjfvmaHIfPtO6vySFGDL1BVV-TC5B7-og",
    authDomain: "pharmavision-7be68.firebaseapp.com",
    projectId: "pharmavision-7be68",
    storageBucket: "pharmavision-7be68.appspot.com",
    messagingSenderId: "674395280400",
    appId: "1:674395280400:web:8ffacc3daa3821bbafa695",
    measurementId: "G-Y1NBR12227",
    vapidKey: "BKW2FnEGHYYMGu13bfLLFxAJirTO0lpj6ueAfUb8skqarqS37JYflbsBf3DbK4O76XwSlRy_g1YkbipAL44eMpI"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
